import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAeVcYsSd8F4XdxebgAydFFNuFsTwXwT9M",
  authDomain: "shelbuladev.firebaseapp.com",
  projectId: "shelbuladev",
  storageBucket: "shelbuladev.firebasestorage.app",
  messagingSenderId: "988139464059",
  appId: "1:988139464059:web:e31693e52813a2643d09de",
  measurementId: "G-HW3S0Y7X4M"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);